import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import HeaderOne from "../components/HeaderOne";
import "./PartnerDashboard.scss";
import "./PartnerDashboardScroll.scss";
import { partnerPageComponents } from "../components/partner/PartnerPageContent";
import PartnerActivityPage from "../components/partner/PartnerActivityPage";

const menu = [
  ["activity", "/assets/images/icons/my-activity.svg", "Իմ ակտիվությունը"],
  ["clients", "/assets/images/icons/partner-list.svg", "Հաճախորդների ցանկ"],
  ["statistics", "/assets/images/icons/diagram.svg", "Վիճակագրություն"],
  ["applications", "/assets/images/icons/application-history.svg", "Հայտի պատմությունը"],
  ["payments", "/assets/images/icons/receipt.svg", "Վճարումների պատմություն"],
  ["messages", "/assets/images/icons/messages-2.svg", "Նամակագրություն"],
];

export default function PartnerDashboard() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const active = location.pathname.split("/").pop() || "activity";
  const [isDashboardMenuOpen, setIsDashboardMenuOpen] = useState(false);

  const selectPage = (id) => {
    navigate(`/${i18n.language}/partner/${id}`);
  };


  return (
    <>
      <div className="partner-dashboard__site-header"><HeaderOne isAuthenticated isPartnerDashboard dashboardMenu={menu} onDashboardMenuToggle={(id) => { if (id) selectPage(id); setIsDashboardMenuOpen(false); }} /></div>
      <div className="partner-dashboard">
        <div className="partner-dashboard__body">
          <aside className={`partner-dashboard__sidebar ${isDashboardMenuOpen ? "is-open" : ""}`}>
            <nav aria-label="Գործընկերոջ մենյու">
              {menu.map(([id, icon, label]) => (
                <button key={id} className={`partner-dashboard__nav-item ${active === id ? "is-active" : ""}`} onClick={() => { selectPage(id); setIsDashboardMenuOpen(false); }}>
                  {typeof icon === "string" && icon.startsWith("/") ? <img className="partner-dashboard__nav-icon" style={{ width: 24, height: 24, objectFit: "contain", filter: active === id ? "brightness(0) invert(1)" : "brightness(0)" }} src={icon} alt="" /> : <i className={`las ${icon}`} />}
                  <span>{label}</span>
                </button>
              ))}
            </nav>
          </aside>

          <main className="partner-dashboard__content">
            <div className="partner-dashboard__scroll-content">
              <div className="partner-dashboard__title-row">
                <div><h1>{menu.find(([id]) => id === active)?.[2] || "Իմ ակտիվությունը"}</h1><p>Հետևեք ձեր գործընկերային ծրագրի արդյունքներին</p></div>
              </div>
              {active === "activity" ? <PartnerActivityPage /> : partnerPageComponents[active] ? (() => { const Page = partnerPageComponents[active]; return <Page />; })() : <>
                <section className="partner-dashboard__stats">
                  <article><span className="stat-icon"><i className="las la-user-friends" /></span><div><small>Ընդհանուր հաճախորդներ</small><strong>24</strong><em>+12.5% նախորդ ամսվա համեմատ</em></div></article>
                  <article><span className="stat-icon"><i className="las la-chart-bar" /></span><div><small>Ակտիվ հաճախորդներ</small><strong>18</strong><em>+8.2% նախորդ ամսվա համեմատ</em></div></article>
                  <article><span className="stat-icon"><i className="las la-wallet" /></span><div><small>Ընդհանուր եկամուտ</small><strong>485,000 ֏</strong><em>+15.8% նախորդ ամսվա համեմատ</em></div></article>
                </section>
                <section className="partner-dashboard__panel">
                  <div className="partner-dashboard__panel-header"><div><h2>Ակտիվության ամփոփում</h2><p>Ձեր գործընկերային ակտիվության դինամիկան</p></div><button>Վերջին 6 ամիս <i className="las la-angle-down" /></button></div>
                  <div className="partner-dashboard__chart"><div className="chart-y"><span>500k</span><span>400k</span><span>300k</span><span>200k</span><span>100k</span><span>0</span></div><div className="chart-area"><div className="chart-line" /><div className="chart-bars"><i /><i /><i /><i /><i /><i /></div><div className="chart-x"><span>Հուն</span><span>Փետ</span><span>Մար</span><span>Ապր</span><span>Մայ</span><span>Հուն</span></div></div></div>
                </section>
              </>}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
